import * as React from 'react';
import { Heading4, Paragraph } from '../../../elements';
import { Modal } from '../../../modal/Modal';
import classnames from 'classnames';
const ReportNotificationModal = props => {
    const { onCloseClick, onConfirmClick, onDenyClick, header, body } = props;
    return (React.createElement(Modal, { className: classnames('ReportNotificationModal', {
            'ReportNotificationModal--noCta': !onConfirmClick
        }), onDenyClick: onDenyClick, onConfirmClick: onConfirmClick, onCloseClick: onCloseClick, large: true },
        React.createElement(Heading4, null, header),
        React.createElement(Paragraph, null, body)));
};
export default ReportNotificationModal;
